import { RefObject, useEffect, useId, useRef } from "react";

export const useAssociatedFieldId = (): {
    fieldId: string;
    fieldRef: RefObject<HTMLDivElement | null>;
} => {
    const fieldId = useId();
    const fieldRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const control = fieldRef.current?.querySelector<HTMLElement>(
            "input:not([type='hidden']), textarea, select",
        );

        if (control) {
            control.id = fieldId;
        }
    });

    return { fieldId, fieldRef };
};
